<div class="container-fluid h-75">
  <div class="row row-padding-top-lg">
    <div class="col">
      <label class="fs-32 bold">Vendors</label>
    </div>
  </div>

  <div class="row grid-container">
    <div class="col">
      <app-vendors-grid
        [gridName]="'VIVEVendors'"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        (rowClick)="actionEvent({ action: 'view', rowData: $event.data })"
      ></app-vendors-grid>
    </div>
  </div>
</div>
